"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentItemFieldKey = (ci, key, nestedKey = 'data') => {
    return ci[key] && ci[key][nestedKey];
};
//# sourceMappingURL=getContentItemFieldKey.js.map